import {
  Component,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges
} from '@angular/core';
import { Observable } from 'rxjs';
import {
  DimensionParser,
  EventId,
  Image
} from 'src/app/services/xml-parser-service/xml-parser.service';
import { PageService } from '../../service/page-service.service';
import { VisibilityWatchers } from '../visibility-watchers/visibility-watchers';

@Component({
  selector: 'app-content-image',
  templateUrl: './content-image.component.html',
  styleUrls: ['./content-image.component.css'],
  standalone: false
})
export class ContentImageComponent implements OnChanges, OnDestroy {
  @Input() item: Image;

  image: Image;
  ready: boolean;
  imgResource: string;
  isFirstPage$: Observable<boolean>;
  width: string;
  events: EventId[];
  isEventType: boolean;
  visibility: VisibilityWatchers;
  isClickable: boolean;

  constructor(private pageService: PageService) {
    this.isFirstPage$ = this.pageService.isFirstPage$;
    this.visibility = new VisibilityWatchers(this.pageService);
  }

  ngOnDestroy(): void {
    this.visibility.closeWatchers();
  }

  ngOnChanges(changes: SimpleChanges) {
    for (const propName in changes) {
      if (changes.hasOwnProperty(propName)) {
        switch (propName) {
          case 'item': {
            if (
              !changes['item'].previousValue ||
              changes['item'].currentValue !== changes['item'].previousValue
            ) {
              this.ready = false;
              this.imgResource = '';
              this.image = this.item;
              this.init();
            }
          }
        }
      }
    }
  }

  onClick(): void {
    this.pageService.handleClickable(this.image.events);
  }

  private init(): void {
    this.visibility.init(this.image);

    this.imgResource =
      this.pageService.getResourceUrl(this.image.resource) || '';
    const dimensions = DimensionParser(this.image.width);
    this.width = dimensions?.value
      ? dimensions.value + dimensions.symbol
      : null;
    this.isClickable = this.image.isClickable;
    this.ready = true;
  }
}
